import { qsa } from "../inc/dom.js";

const initListpage = () => {
    const root = document.querySelector(".lp");
    if (!root) return;
    const results = root.querySelector("#oi-filter-results");
    const search = root.querySelector(".lp-search-input");
    const sortWrap = root.querySelector("[data-lp-sort]");
    const sortToggle = root.querySelector("[data-lp-sort-toggle]");
    const sortValueEl = root.querySelector("[data-lp-sort-value]");
    const more = root.querySelector(".lp-more");
    const empty = root.querySelector(".lp-empty");
    if (!results) return;
    const batch = 12;
    let shown = batch;
    let sortMode = "featured";

    const num = (col, attr) => parseFloat(col.getAttribute(attr)) || 0;
    let originalOrder = [];

    const capture = () => {
        const grid = results.querySelector(".plan-grid");
        originalOrder = grid ? qsa(".plan-col", grid) : [];
    };

    const resetLink = root.querySelector("[data-lp-reset]");
    if (resetLink) {
        resetLink.addEventListener("click", () => {
            const wrap = root.querySelector(".lp-results-wrap");
            if (wrap) wrap.classList.add("is-loading");
            const loader = root.querySelector("[data-lp-loader]");
            if (loader) loader.hidden = false;
        });
    }
    const filterSelects = qsa("select[name]", root);
    const updateReset = () => {
        if (!resetLink) return;
        let active = filterSelects.some((s) => s.value);
        if (root.querySelector("[data-lp-chip][data-filter='feature'].active")) active = true;
        const coll = root.querySelector("[data-lp-chip][data-filter='collection'].active");
        if (coll && coll.getAttribute("data-value")) active = true;
        if (search && search.value.trim()) active = true;
        if (sortMode && sortMode !== "featured") active = true;
        resetLink.hidden = !active;
    };

    const applySort = () => {
        const grid = results.querySelector(".plan-grid");
        if (!grid) return;
        const mode = sortMode;
        if (mode === "featured") {
            originalOrder.forEach((col) => grid.appendChild(col));
            return;
        }
        const cols = qsa(".plan-col", grid);
        cols.sort((a, b) => {
            if (mode === "sqft-asc") return num(a, "data-sqft") - num(b, "data-sqft");
            if (mode === "sqft-desc") return num(b, "data-sqft") - num(a, "data-sqft");
            if (mode === "price-asc") return num(a, "data-price") - num(b, "data-price");
            if (mode === "price-desc") return num(b, "data-price") - num(a, "data-price");
            if (mode === "name") {
                return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || "");
            }
            return 0;
        });
        cols.forEach((col) => grid.appendChild(col));
    };

    const apply = () => {
        const term = search ? search.value.trim().toLowerCase() : "";
        const cols = qsa(".plan-col", results);
        let matched = 0;
        cols.forEach((col) => {
            if (col.classList.contains("lp-chip-hidden") || col.classList.contains("lp-variant-hidden")) {
                col.hidden = true;
                return;
            }
            const name = (col.getAttribute("data-name") || "").toLowerCase();
            const hit = !term || name.indexOf(term) !== -1;
            if (!hit) {
                col.hidden = true;
                return;
            }
            col.hidden = matched >= shown;
            matched += 1;
        });
        if (more) more.hidden = matched <= shown;
        if (empty) empty.hidden = matched !== 0 || !cols.length;
        updateReset();
    };

    const render = () => {
        applySort();
        apply();
    };

    if (search) {
        search.addEventListener("input", () => {
            shown = batch;
            apply();
        });
    }
    if (sortWrap && sortToggle) {
        const opts = qsa(".lp-sort-opt", sortWrap);
        sortToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            const open = sortWrap.classList.toggle("is-open");
            sortToggle.setAttribute("aria-expanded", String(open));
        });
        opts.forEach((opt) => {
            opt.addEventListener("click", () => {
                sortMode = opt.getAttribute("data-value") || "featured";
                opts.forEach((o) => o.classList.remove("active"));
                opt.classList.add("active");
                if (sortValueEl) sortValueEl.textContent = opt.textContent;
                sortWrap.classList.remove("is-open");
                sortToggle.setAttribute("aria-expanded", "false");
                shown = batch;
                render();
            });
        });
        document.addEventListener("click", (e) => {
            if (!sortWrap.contains(e.target)) {
                sortWrap.classList.remove("is-open");
                sortToggle.setAttribute("aria-expanded", "false");
            }
        });
    }
    const countySelect = root.querySelector("[data-lp-county]");
    const syncPriceSort = () => {
        if (!sortWrap || !countySelect) return;
        const locked = !countySelect.value;
        qsa(".lp-sort-opt[data-value^='price']", sortWrap).forEach((opt) => {
            opt.parentElement.hidden = locked;
        });
        if (locked && sortMode.indexOf("price") === 0) {
            const featured = sortWrap.querySelector(".lp-sort-opt[data-value='featured']");
            if (featured) featured.click();
        }
    };
    if (countySelect) countySelect.addEventListener("change", syncPriceSort);
    syncPriceSort();
    if (more) {
        more.addEventListener("click", () => {
            shown += batch;
            apply();
        });
    }
    document.addEventListener("lp:rerender", () => {
        shown = batch;
        render();
    });
    document.addEventListener("lp:content", () => {
        capture();
        render();
        if (window.initPlanCardGalleries) window.initPlanCardGalleries(results);
    });

    capture();
    apply();

    const observer = new MutationObserver(() => {
        shown = batch;
        capture();
        render();
        if (window.initPlanCardGalleries) window.initPlanCardGalleries(results);
    });
    observer.observe(results, { childList: true });
};

const initListpageFilters = () => {
    const bar = document.querySelector(".lp-filters");
    if (!bar) return;

    const toggle = bar.querySelector("[data-lp-advanced-toggle]");
    const panel = document.getElementById("lpAdvanced");
    if (toggle && panel) {
        toggle.addEventListener("click", () => {
            const open = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", String(!open));
            panel.classList.toggle("is-open", !open);
        });
    }

    const county = bar.querySelector("[data-lp-county]");
    const priceCell = bar.querySelector("[data-lp-price]");
    const priceSelect = bar.querySelector("[data-lp-price-select]");
    const priceTip = bar.querySelector("[data-lp-price-tooltip]");
    const syncPriceLock = () => {
        if (!priceCell || !priceSelect) return;
        const locked = !county || !county.value;
        priceCell.classList.toggle("is-locked", locked);
        priceSelect.disabled = locked;
        if (locked) priceSelect.value = "";
    };
    if (county) {
        county.addEventListener("change", () => {
            if (county.form) county.form.dataset.filterType = county.value ? "floorplan-county" : "floorplan";
            if (priceSelect) priceSelect.value = "";
            syncPriceLock();
        });
    }

    const countyDD = bar.querySelector("[data-lp-county-dd]");
    const countyToggle = bar.querySelector("[data-lp-county-toggle]");
    const countyValueEl = bar.querySelector("[data-lp-county-value]");
    if (countyDD && countyToggle && county) {
        const cOpts = qsa(".lp-county-opt", countyDD);
        const syncCountyUI = () => {
            cOpts.forEach((o) => o.classList.toggle("active", o.getAttribute("data-value") === county.value));
            const active = cOpts.find((o) => o.getAttribute("data-value") === county.value);
            if (countyValueEl && active) countyValueEl.textContent = active.textContent;
        };
        syncCountyUI();
        countyToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            const open = countyDD.classList.toggle("is-open");
            countyToggle.setAttribute("aria-expanded", String(open));
        });
        cOpts.forEach((opt) => {
            opt.addEventListener("click", () => {
                county.value = opt.getAttribute("data-value");
                county.dispatchEvent(new Event("change", { bubbles: true }));
                syncCountyUI();
                countyDD.classList.remove("is-open");
                countyToggle.setAttribute("aria-expanded", "false");
            });
        });
        document.addEventListener("click", (e) => {
            if (!countyDD.contains(e.target)) {
                countyDD.classList.remove("is-open");
                countyToggle.setAttribute("aria-expanded", "false");
            }
        });
    }

    if (priceCell && priceTip) {
        let tipTimer = null;
        priceCell.addEventListener("click", () => {
            if (!priceCell.classList.contains("is-locked")) return;
            priceCell.classList.add("show-tip");
            if (tipTimer) clearTimeout(tipTimer);
            tipTimer = setTimeout(() => priceCell.classList.remove("show-tip"), 2600);
        });
    }
    syncPriceLock();

    const applyChips = () => {
        const activeFeatures = qsa("[data-lp-chip][data-filter='feature'].active", bar).map((c) => c.getAttribute("data-value"));
        const activeCollectionChip = bar.querySelector("[data-lp-chip][data-filter='collection'].active");
        const activeCollection = activeCollectionChip ? activeCollectionChip.getAttribute("data-value") : "";
        qsa(".plan-col", document).forEach((col) => {
            const feats = (col.getAttribute("data-features") || "").split(/\s+/).filter(Boolean);
            const coll = col.getAttribute("data-collection") || "";
            let ok = true;
            if (activeFeatures.length) ok = activeFeatures.some((f) => feats.indexOf(f) !== -1);
            if (ok && activeCollection) ok = coll === activeCollection;
            col.classList.toggle("lp-chip-hidden", !ok);
        });
        document.dispatchEvent(new Event("lp:rerender"));
    };

    qsa("[data-lp-chip]", bar).forEach((chip) => {
        chip.addEventListener("click", () => {
            const group = chip.parentElement;
            const filter = chip.getAttribute("data-filter");
            if (filter === "collection") {
                const wasActive = chip.classList.contains("active");
                qsa("[data-lp-chip]", group).forEach((c) => c.classList.remove("active"));
                if (!wasActive) chip.classList.add("active");
            } else {
                chip.classList.toggle("active");
            }
            applyChips();
        });
    });
};

const initListpageVariantTabs = () => {
    const tabs = document.querySelector("[data-lp-variant-tabs]");
    if (!tabs) return;
    const buttons = qsa("[data-lp-variant]", tabs);
    if (!buttons.length) return;

    // The map reads markers from cards matching [data-listing-type], and runs
    // with show_hidden so paging does not drop pins. Swapping the attribute is
    // therefore the only way a tab can take a card off the map as well as out
    // of the rail.
    const refreshMap = () => {
        const map = window.oi && window.oi.loaded && window.oi.loaded.map && window.oi.loaded.map["oi-map"];
        if (!map) return;
        map.set_markers("location");
        map.fit();
    };

    const apply = () => {
        const active = tabs.querySelector("[data-lp-variant].active");
        const variant = active ? active.getAttribute("data-lp-variant") : "";
        qsa(".plan-col", document).forEach((col) => {
            const match = !variant || col.getAttribute("data-variant") === variant;
            col.classList.toggle("lp-variant-hidden", !match);
            col.setAttribute("data-listing-type", match ? "location" : "location-off");
        });
        document.dispatchEvent(new Event("lp:rerender"));
        refreshMap();
    };

    buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
            buttons.forEach((b) => {
                b.classList.remove("active");
                b.setAttribute("aria-selected", "false");
            });
            btn.classList.add("active");
            btn.setAttribute("aria-selected", "true");
            apply();
        });
    });

    apply();
    document.addEventListener("lp:content", apply);
    const results = document.getElementById("oi-filter-results");
    if (results) new MutationObserver(apply).observe(results, { childList: true });
};

const initListpageDrawer = () => {
    const drawer = document.getElementById("lpFilterDrawer");
    const openBtn = document.getElementById("lpFilterOpen");
    if (!drawer || !openBtn) return;
    const overlay = document.getElementById("lpFilterOverlay");
    const closeBtn = document.getElementById("lpFilterClose");
    const doneBtn = document.getElementById("lpFilterApply");
    const open = () => {
        document.dispatchEvent(new CustomEvent("oi:drawer-open", { detail: { source: "filter" } }));
        drawer.classList.add("open");
        if (overlay) overlay.classList.add("open");
        openBtn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
    };
    const close = () => {
        drawer.classList.remove("open");
        if (overlay) overlay.classList.remove("open");
        openBtn.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
    };
    const closeAndScroll = () => {
        close();
        const target = document.getElementById("oi-filter-results");
        if (!target) return;
        const nav = document.getElementById("site-nav");
        const offset = (nav ? nav.offsetHeight : 0) + 16;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: "smooth" });
    };
    openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (doneBtn) doneBtn.addEventListener("click", closeAndScroll);
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && drawer.classList.contains("open")) close();
    });
    document.addEventListener("oi:drawer-open", (e) => {
        if (e.detail && e.detail.source !== "filter" && drawer.classList.contains("open")) close();
    });
};

initListpage();
initListpageFilters();
initListpageVariantTabs();
initListpageDrawer();
